module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/icon--service-7462cfb07b0b59868355a0469470b575.svg";